{
  "el": {
    "decision": {
      "actions": {
        "add": "Προσθήκη",
        "addDocument": "Προσθήκη εγγράφου",
        "addUnits": "Ακίνητα",
        "approve": "Έγκριση",
        "autoCloseAfterApproval": "Αυτόματο κλείσιμο μετά την έγκριση",
        "autoCloseAfterApprovalInfo": "Η απόφαση κλείνει όταν εγκριθεί μια πρόταση",
        "autoCloseAfterDeadline": "Αυτόματο κλείσιμο μετά την προθεσμία",
        "cancel": "Αναίρεση",
        "changeResponsible": "Αλλαγή υπευθύνου",
        "clickToSetDeadline": "Κάνε κλικ για να ορίσεις προθεσμία",
        "closeDecision": "Κλείσιμο απόφασης",
        "confirmChoices": "Επιβεβαίωση επιλογών",
        "createProposal": "Δημιουργία πρότασης",
        "create_decisions": "Δημιουργία απόφασης | Δημιουργία αποφάσεων",
        "delete": "Διαγραφή",
        "deleteCount": "Πρόκειται να διαγράψεις {count} απόφαση. Θέλεις σίγουρα να συνεχίσεις; | Πρόκειται να διαγράψεις {count} αποφάσεις. Θέλεις σίγουρα να συνεχίσεις;",
        "deleteMultipleDecisions": "Διαγραφή...",
        "delete_cancel": "Ακύρωση",
        "delete_decisions": "Διαγραφή απόφασης | Διαγραφή αποφάσεων",
        "edit": "Επεξεργασία",
        "editBudget": "Επεξεργασία προϋπολογισμού",
        "editDeadline": "Επεξεργασία προθεσμίας",
        "editDecision": "Επεξεργασία απόφασης",
        "editReminders": "Επεξεργασία υπενθυμίσεων",
        "goToDecision": "Μετάβαση στην απόφαση",
        "goToProposal": "Μετάβαση στην πρόταση",
        "goToSummary": "Μετάβαση στη σύνοψη",
        "hide": "Κατάργηση δημοσίευσης",
        "hideInfo": "Απόκρυψη πληροφοριών",
        "noDescription": "Κάνε κλικ για να προσθέσεις περιγραφή",
        "openDecision": "Άνοιγμα απόφασης",
        "publish": "Δημοσίευση",
        "publishAll": "Για όλους",
        "publishCustomer": "Δημοσίευση για τον πελάτη",
        "publishPartners": "Δημοσίευση για τους συνεργάτες",
        "reject": "Απόρριψη",
        "relaunch_decision": "Επανεκκίνηση απόφασης",
        "request_changes": "Αίτημα αλλαγών",
        "reset": "Επαναφορά",
        "save": "Αποθήκευση",
        "save_and_share_partners": "Αποθήκευση και κοινοποίηση στους συνεργάτες",
        "selectAll": "Επιλογή και των {total} ακινήτων",
        "selectChoices": "Δήλωση επιλογών",
        "share_proposals": "Κοινοποίηση προτάσεων",
        "showMoreInfo": "Εμφάνιση περισσότερων πληροφοριών",
        "stopApproving": "Διακοπή έγκρισης",
        "submit": "Υποβολή",
        "tickBoxesDeletion": "Τσέκαρε τα πλαίσια των αρχείων που θέλεις να διαγραφούν.",
        "unSelectAll": "Εκκαθάριση επιλογής.",
        "unpublishForCustomer": "Κατάργηση δημοσίευσης για τον πελάτη",
        "unpublishForPartners": "Κατάργηση δημοσίευσης για τον συνεργάτη απόφασης",
        "update": "Ενημέρωση",
        "upload": "Ανέβασμα",
        "upload_documents": "Ανέβασμα εγγράφων",
        "upload_proposals": "Δημιουργία πρότασης"
      },
      "attributes": {
        "amount_gross": "Μεικτή προσφορά",
        "amount_net": "Καθαρή προσφορά",
        "approved_at": "Ημερομηνία έγκρισης πρότασης",
        "approved_proposal_name": "Εγκεκριμένη πρόταση",
        "bathrooms": "Αριθμός μπάνιων",
        "bedrooms": "Αριθμός υπνοδωματίων",
        "category": "Κατηγορία",
        "customer_group_name": "Πελάτης",
        "decision_name": "Απόφαση",
        "decisions_count": "{count} απόφαση | {count} αποφάσεις",
        "due_date": "Προθεσμία",
        "floor": "Όροφος",
        "negative_surcharges_allowed": "Να επιτρέπεται πίστωση",
        "note_employee": "Σημείωση",
        "price_budget": "Προϋπολογισμός",
        "price_budget_extra": "Επιπλέον προϋπολογισμός",
        "price_budget_info": "Μπορείς πάντα να επεξεργαστείς τον προϋπολογισμό αργότερα",
        "price_budget_info_mup": "Μπορείς πάντα να επεξεργαστείς τον προϋπολογισμό ανά ακίνητο αργότερα",
        "price_margin": "Περιθώριο",
        "price_surcharge": "Αναβάθμιση",
        "published": "Δημοσιευμένο",
        "responsible": "Υπεύθυνος",
        "status": "Κατάσταση",
        "unit": "Ακίνητο",
        "verification_type": "Η απόφαση έγκρισης δίνεται από",
        "visibility": "Ορατότητα"
      },
      "edit_actions": {
        "edit_auto_close": "Επιλογές αυτόματου κλεισίματος",
        "edit_close_decision": "Κλείσιμο/Άνοιγμα απόφασης",
        "edit_deadline": "Ορισμός προθεσμίας",
        "edit_margin": "Ορισμός περιθωρίων",
        "edit_negative_surcharges_allowed": "Να επιτρέπεται πίστωση",
        "edit_not_interested_allowed": "Να επιτρέπεται η επιλογή «Χωρίς ενδιαφέρον»",
        "edit_note_employee": "Επεξεργασία σημείωσης",
        "edit_price_budget": "Ορισμός προϋπολογισμού",
        "edit_price_budget_extra": "Ορισμός επιπλέον προϋπολογισμού",
        "edit_reminders": "Ορισμός υπενθυμίσεων",
        "edit_responsible": "Ορισμός υπευθύνου"
      },
      "labels": {
        "accessRights": "Δικαιώματα πρόσβασης",
        "activity": "Ιστορικό",
        "addDecisionNote": "Προσθήκη σημείωσης",
        "addReminders": "Προσθήκη υπενθυμίσεων",
        "allUnits": "Όλα τα ακίνητα",
        "allUnitsAssigned": "Έχουν ανατεθεί όλα τα ακίνητα",
        "allow_not_interested": "Να επιτρέπεται η επιλογή «Χωρίς ενδιαφέρον»",
        "allow_not_interested_cancel_warning": "Αυτή η απόφαση είναι αυτή τη στιγμή σημειωμένη ως «Χωρίς ενδιαφέρον». Αν απενεργοποιήσεις αυτή την επιλογή, θα γίνει ακύρωση της κατάστασης «Χωρίς ενδιαφέρον».",
        "allow_not_interested_info": "Εμφανίζει μια επιλογή «Χωρίς ενδιαφέρον» δίπλα στις προτάσεις",
        "approved": "Εγκεκριμένη",
        "approvedAt": "Εγκρίθηκε {approved_at}",
        "approvedProposal": "Εγκεκριμένη πρόταση",
        "askQuestion": "Κάνε εδώ τις ερωτήσεις σου σχετικά με την απόφασή σου {decision}",
        "assignCustomerToUnit": "Ανάθεση πελάτη",
        "autoClose": "Αυτόματο κλείσιμο",
        "budgetOverview": "Επισκόπηση προϋπολογισμού",
        "budgetSubtitle": "Καταχώρισε εδώ έναν προϋπολογισμό αν ισχύει για όλα τα επιλεγμένα ακίνητα ή πρόσθεσε προϋπολογισμούς αργότερα",
        "budgetTitle": "Ορισμός προϋπολογισμού",
        "checkbox": "Πλαίσιο ελέγχου",
        "clickHereToChange": "Κάνε κλικ εδώ αν θέλεις να τα αλλάξεις.",
        "close": "Κλείσιμο",
        "closeDecision": "Κλείσιμο απόφασης",
        "closed": "Η απόφαση είναι κλειστή για αυτό το ακίνητο. Ο πελάτης δεν θα μπορεί πλέον να εγκρίνει πρόταση.",
        "closedLabel": "Κλειστή",
        "closed_tag": "Κλειστή απόφαση",
        "closed_tooltip_customer": "Η απόφαση είναι κλειστή. Δεν θα μπορείς πλέον να εγκρίνεις πρόταση.",
        "countDocuments": "Κανένα έγγραφο ακόμη | 1 έγγραφο | {count} έγγραφα",
        "countEdit": "Επεξεργασία της απόφασης {count} ακινήτου | Επεξεργασία της απόφασης {count} ακινήτων",
        "countUpload": "Ανέβασμα εγγράφων σε αυτό το ακίνητο | Ανέβασμα εγγράφων σε {count} ακίνητα",
        "created_on": "Η απόφαση δημιουργήθηκε στις {date}",
        "custom_columns_title": "Μπορείς να προσθέσεις έως 10 στήλες",
        "customer": "Πελάτης",
        "customer_status": "Κατάσταση πελάτη",
        "decided": "Αποφασίστηκε",
        "decision": "Απόφαση",
        "decisionBreadcrumb": "Απόφαση {decision_type}",
        "decisionNotPublishedYetFor": "Η απόφαση δεν έχει δημοσιευτεί ακόμη για",
        "decisionNoteExplainer": "Αυτή η σημείωση είναι ορατή μόνο στην ομάδα σου και στους συνεργάτες που έχουν δικαίωμα να δουν αυτή την απόφαση",
        "decisionType": "Θέμα απόφασης",
        "decisionUnit": "Απόφαση για το ακίνητο {unit}",
        "decisions": "Αποφάσεις",
        "decisions_all_projects": "Αποφάσεις όλων των έργων",
        "decisions_breadcrumb": "Αποφάσεις {project}",
        "default": "Προεπιλογή",
        "deleteExplanation": "Όλα τα μηνύματα επικοινωνίας, τα αρχεία, οι προτάσεις και τα υπόλοιπα δεδομένα θα αφαιρεθούν οριστικά από την πλατφόρμα. Οι πελάτες και οι συνεργάτες που σχετίζονται με αυτές τις αποφάσεις θα χάσουν κάθε πρόσβαση.",
        "descriptionSubtitle": "Εδώ μπορείς να προσθέσεις περισσότερες πληροφορίες για τους πελάτες σου",
        "descriptionTitle": "Πρόσθεσε μια περιγραφή για τον πελάτη σου",
        "documentRequired": "Απαιτείται υπογεγραμμένο έγγραφο για την έγκριση",
        "documentUnits": "Φάκελος ακινήτου",
        "documents": "Έγγραφα",
        "dueDate": "Προθεσμία {date}",
        "due_date_subtitle": "Όρισε μια ημερομηνία μέχρι την οποία πρέπει να ληφθεί η απόφαση",
        "due_date_title": "Προθεσμία και υπενθυμίσεις",
        "editDecisionNote": "Επεξεργασία σημείωσης",
        "extra_options": "Επιπλέον επιλογές",
        "false": "Όχι",
        "filter": "Φίλτρο",
        "finalSettings": "Μερικές προαιρετικές ρυθμίσεις",
        "finalSettingsStep": "Τελικές ρυθμίσεις",
        "financial": "Οικονομικά",
        "firstThingsfirst": "Ας ξεκινήσουμε με μερικές γενικές πληροφορίες",
        "follow": "Παρακολούθηση",
        "following": "Παρακολουθείς — θα λαμβάνεις ειδοποιήσεις",
        "four": "4",
        "giveNewAmount": "Δώσε νέο ποσό",
        "hideCount": "Κατάργηση δημοσίευσης αυτής της απόφασης για 1 ακίνητο | Κατάργηση δημοσίευσης της απόφασης για {count} ακίνητα",
        "hideVisibilitySettings": "Απόκρυψη ρυθμίσεων ορατότητας",
        "indicate_not_interested": "Δήλωσε ότι ο πελάτης δεν ενδιαφέρεται για αυτή την απόφαση",
        "info": "Εμφάνιση περισσότερων πληροφοριών",
        "infoCustomers": "Στοιχεία πελάτη",
        "information": "Πληροφορίες",
        "leaveBudgetEmptyInfo": "Άφησέ το κενό αν δεν θέλεις να χρησιμοποιήσεις αναβαθμίσεις και πίστωση",
        "make_a_decision": "Λήψη απόφασης",
        "marginOnBudget": "Περιθώριο στον προϋπολογισμό (%)",
        "marginOnUpgrades": "Περιθώριο στις αναβαθμίσεις (%)",
        "marginOnUpgradesExplainer": "Το περιθώριο στις αναβαθμίσεις εφαρμόζεται και στους επιπλέον προϋπολογισμούς που δίνεις σε έναν πελάτη. Ο επιπλέον προϋπολογισμός ορίζεται μέσα στην απόφαση ενός ακινήτου.",
        "marginOverview": "Επισκόπηση περιθωρίων",
        "marginSubTitle": "Αυτόματος υπολογισμός των περιθωρίων ως ποσοστά",
        "marginTitle": "Χρήση ποσοστών περιθωρίου",
        "members": "Μέλη",
        "modifyLater": "Μπορείς να αλλάξεις αυτές τις ρυθμίσεις αργότερα",
        "name": "Όνομα",
        "newActivity": "Νέα στο ιστορικό",
        "newDocument": "Νέα έγγραφα",
        "next": "Επόμενο",
        "no": "Όχι",
        "noApprovedProposalYet": "Καμία πρόταση δεν έχει εγκριθεί ακόμη",
        "noBudget": "Δεν έχει οριστεί προϋπολογισμός",
        "noCustomer": "Δεν υπάρχει πελάτης ακόμη",
        "noCustomerAssigned": "Δεν έχει ανατεθεί ακόμη πελάτης στο ακίνητο",
        "noDeadline": "Χωρίς προθεσμία",
        "noDecisionDueDate": "Επίλεξε προθεσμία",
        "noDecisionStartDate": "Δεν έχει οριστεί ημερομηνία έναρξης",
        "noDecisionsMade": "Δεν έχουν ληφθεί αποφάσεις ακόμη",
        "noDecisionsToMake": "Δεν υπάρχουν αποφάσεις προς λήψη.",
        "noDecisionsYet": "Δεν υπάρχουν αποφάσεις ακόμη",
        "noDocumentsShared": "Δεν έχουν κοινοποιηθεί έγγραφα",
        "noDueDate": "Όρισε πρώτα προθεσμία πριν ορίσεις υπενθυμίσεις",
        "noDueDateSet": "Δεν έχει οριστεί προθεσμία",
        "noExtraBudget": "Χωρίς επιπλέον προϋπολογισμό",
        "noMessages": "Γράψε το πρώτο σου μήνυμα για {decision} στο πλαίσιο παρακάτω",
        "noUnitDocuments": "Δεν έχουν προστεθεί ακόμη έγγραφα στον φάκελο του ακινήτου",
        "noUnitsClick": "Δεν υπάρχουν ακίνητα ακόμη, κάνε κλικ εδώ για να προσθέσεις",
        "no_result_for_search": "Κανένα αποτέλεσμα για αυτή τη φιλτραρισμένη αναζήτηση.",
        "no_surcharges": "Χωρίς αναβαθμίσεις",
        "no_surcharges_info": "Προτάσεις χωρίς οικονομικές αναβαθμίσεις",
        "notDecided": "Δεν έχει αποφασιστεί ακόμη",
        "notDecidedYet": "Ο πελάτης δεν έχει πάρει ακόμη απόφαση.",
        "notFollowing": "Δεν παρακολουθείς — κάνε κλικ για να λαμβάνεις ειδοποιήσεις",
        "notPossibleToWriteMessageDeactivatedUnit": "Αυτή η απόφαση σχετίζεται με απενεργοποιημένο ακίνητο. Δεν είναι πλέον δυνατή η συγγραφή νέου μηνύματος.",
        "notPublished": "Μη δημοσιευμένο",
        "notPublishedCustomer": "Η απόφαση δεν έχει δημοσιευτεί ακόμη για τον πελάτη",
        "notPublishedPartners": "Η απόφαση δεν έχει δημοσιευτεί ακόμη για τους συνεργάτες απόφασης",
        "notShared": "Μη κοινοποιημένο",
        "not_interested": "Χωρίς ενδιαφέρον",
        "not_interested_customer": "Χωρίς ενδιαφέρον",
        "not_interested_customer_info": "Αν δεν σε ενδιαφέρει αυτή η απόφαση ή δεν σε αφορά, κάνε κλικ εδώ για να το δηλώσεις.",
        "not_interested_modal": {
          "customer": {
            "body": "Δώσε μας λίγα παραπάνω σχόλια για το γιατί δεν σε ενδιαφέρει αυτή η απόφαση",
            "title": "Δεν με ενδιαφέρει αυτή η απόφαση"
          },
          "employee": {
            "body": "Δώσε λίγα παραπάνω σχόλια για το γιατί ο πελάτης δεν ενδιαφέρεται για αυτή την απόφαση. Τα σχόλια αυτά θα είναι ορατά και στον πελάτη.",
            "title": "Ο πελάτης δεν ενδιαφέρεται για αυτή την απόφαση"
          },
          "feedback": "Σχόλια"
        },
        "one": "1",
        "open": "Ανοιχτή",
        "openDecisionInfo": "Αυτή η απόφαση είναι ανοιχτή. Ο πελάτης μπορεί να εγκρίνει προτάσεις.",
        "open_auto_close_deadline_unit": "Όρισε αν η απόφαση θα κλείνει αυτόματα με τη λήξη της προθεσμίας",
        "open_auto_close_unit": "Όρισε αν η απόφαση θα κλείνει αυτόματα με την έγκριση ",
        "open_close_unit": "την απόφαση για 1 ακίνητο | την απόφαση για {unit_count} ακίνητα",
        "or": "ή",
        "participants": "Συμμετέχοντες",
        "partners": "Συνεργάτες απόφασης",
        "pendingDecisions": "1 απόφαση προς λήψη | {count} αποφάσεις προς λήψη",
        "priceBudget": "Προϋπολογισμός",
        "priceBudgetExtra": "Επιπλέον προϋπολογισμός",
        "proposal": "Προτάσεις",
        "proposals": "Προτάσεις | 1 πρόταση | {count} προτάσεις",
        "publish?": "Αποθήκευση και δημοσίευση;",
        "publishNow?": "Δημοσίευση τώρα;",
        "publishTopOfPage": "Μπορείς να δημοσιεύσεις αυτή την απόφαση στο πάνω μέρος της σελίδας",
        "publishedCount": "Δημοσίευση αυτής της απόφασης για 1 ακίνητο | Δημοσίευση της απόφασης για {count} ακίνητα",
        "publishedCustomer": "Η απόφαση δημοσιεύτηκε για τον πελάτη",
        "publishedCustomerPartners": "Η απόφαση δημοσιεύτηκε για τον πελάτη και τους συνεργάτες απόφασης",
        "publishedNone": "Δεν έχει δημοσιευτεί ακόμη",
        "publishedPartners": "Η απόφαση δημοσιεύτηκε για τους συνεργάτες απόφασης",
        "publishedSince": "Η απόφαση είναι δημοσιευμένη από {date}",
        "published_info": "Δείχνει αν όλα τα ακίνητα έχουν δημοσιευτεί για πελάτες ή/και συνεργάτες απόφασης",
        "remainOpen": "Να παραμείνει ανοιχτή",
        "reminders": "Υπενθυμίσεις",
        "remindersCount": "1 υπενθύμιση | {count} υπενθυμίσεις",
        "reopenDecision": "Επανάνοιγμα απόφασης",
        "requiresDocumentVerification": "Απαιτεί υπογεγραμμένο έγγραφο για την έγκριση",
        "requiresNoDocumentVerification": "Δεν απαιτείται υπογεγραμμένο έγγραφο για την έγκριση",
        "returnToTickets": "Επιστροφή",
        "rights": {
          "access_full": "Πλήρης πρόσβαση",
          "access_full_info": "Έχει δικαίωμα κοινοποίησης μηνυμάτων, εγγράφων και προτάσεων απευθείας στον πελάτη",
          "access_full_short": "Πλήρης",
          "access_none": "Περιορισμένη πρόσβαση",
          "access_none_info": "Καμία επικοινωνία με τον πελάτη: μόνο για εσωτερική χρήση",
          "access_none_short": "Περιορισμένη",
          "access_semi": "Βασική πρόσβαση",
          "access_semi_info": "Έχει δικαίωμα αποστολής μηνυμάτων στον πελάτη, αλλά όχι εγγράφων ή προτάσεων",
          "access_semi_short": "Βασική",
          "customer_show": "Έχει δικαίωμα να βλέπει τις πληροφορίες του πελάτη.",
          "default": "Οι συνεργάτες απόφασης έχουν ανά πάσα στιγμή δικαίωμα αποστολής μηνυμάτων, ανεβάσματος εγγράφων και δημιουργίας προτάσεων προς την <b>{client_name}</b>. Έχουν επίσης πρόσβαση στα σχέδια στον φάκελο εγγράφων του ακινήτου. Παρακάτω μπορείς να επεξεργαστείς τα δικαιώματα επικοινωνίας τους απέναντι στους πελάτες σου.",
          "document_customer": "Έχει δικαίωμα κοινοποίησης των εγγράφων του απευθείας στον πελάτη.",
          "message_customer": "Έχει δικαίωμα αποστολής μηνυμάτων στον πελάτη.",
          "proposal_customer": "Έχει δικαίωμα κοινοποίησης των προτάσεών του απευθείας στον πελάτη."
        },
        "save?": "Αποθήκευση;",
        "saveExplainer": "Να γίνει αυτή η απόφαση ορατή στους πελάτες σου; Ή να την αποθηκεύσεις και να τη δημοσιεύσεις αργότερα;",
        "select": "Επιλογή",
        "selectOneUnit": "Επίλεξε τουλάχιστον 1 ακίνητο",
        "selectUnits": "Επιλογή ακινήτων",
        "select_units": "Επιλογή ακινήτων",
        "selected": "Επιλέχθηκε {selected} ακίνητο. | Επιλέχθηκαν {selected} ακίνητα.",
        "sharedWith": "Κοινοποιήθηκε σε",
        "showDecisionsFor": "Εμφάνιση αποφάσεων για",
        "show_all_units": "Εμφάνιση όλων των ακινήτων",
        "signOnline": "Πληκτρολόγηση ονόματος για επιβεβαίωση (προεπιλογή)",
        "signUploadDocument": "Ανέβασμα υπογεγραμμένου εγγράφου",
        "signedDocument": "Ανέβασμα υπογεγραμμένου εγγράφου",
        "status": "Κατάσταση",
        "statusExplained": "Τι σημαίνει κάθε κατάσταση απόφασης;",
        "step2Subtitle": "Επίλεξε το έργο σου για να συμπεριλάβεις όλα τα ακίνητά σου με μία κίνηση.",
        "step2Title": "Ποια ακίνητα πρέπει να πάρουν απόφαση;",
        "step2TitleWithDecisionName": "Ποια ακίνητα πρέπει να πάρουν απόφαση για {decision_name};",
        "subject": "Θέμα",
        "summary": "Σύνοψη",
        "surcharge_tooltip": "Αυτή είναι η αναβάθμιση για αυτή την απόφαση",
        "surcharges_total": "Αναβαθμίσεις: {total}",
        "surcharges_total_tooltip": "Αυτό είναι το συνολικό ποσό των αναβαθμίσεων για όλα τα ακίνητα που έχουν αναβάθμιση",
        "three": "3",
        "tickets": "Συνομιλίες",
        "toBeDecided": "Προς απόφαση",
        "toDecide": "Για απόφαση",
        "total": "Σύνολο",
        "totalSelected": "Επιλέχθηκαν και τα {total} ακίνητα.",
        "true": "Ναι",
        "two": "2",
        "type": "Τύπος",
        "unitDecisionsWillBeShownHere": "Εδώ θα εμφανίζονται οι αποφάσεις των ακινήτων",
        "unitNotActivated": "Μόνο για ενεργοποιημένα ακίνητα",
        "unitSelected": "Κανένα ακίνητο | Ένα ακίνητο | {count} ακίνητα",
        "unit_name": "Ακίνητο",
        "units": "Ακίνητα",
        "unpublish": "Μη δημοσιευμένο",
        "unpublished": "Μη δημοσιευμένο",
        "uploadDocument": "Ανέβασμα εγγράφων",
        "useMargins": "Ενεργοποίηση ποσοστών περιθωρίου",
        "use_surcharges": "Χρήση αναβαθμίσεων",
        "use_surcharges_info": "Όρισε προϋπολογισμό για αναβαθμίσεις",
        "validation_errors": "Υπάρχουν προβλήματα με αυτή την πρόταση. Διόρθωσέ τα πρώτα και δοκίμασε ξανά.",
        "waitingForClient": "Αναμονή για τον πελάτη",
        "whatTheCustomerHasBought": "Τι έχει αγοράσει ο πελάτης",
        "when": "Πότε",
        "who": "Ποιος",
        "withAll": "Όλοι",
        "withClient": "Μόνο με {client}",
        "withCustomer": "Με τον πελάτη",
        "withCustomerName": "Με {customer}",
        "withPartners": "Μόνο με τους συνεργάτες απόφασης",
        "yes": "Ναι"
      },
      "legend": {
        "all": "Όλες οι αποφάσεις",
        "approved": "Αποφασίστηκε",
        "approvedAfterDue": "Η πρόταση εγκρίθηκε μετά την προθεσμία",
        "created": "Καμία πρόταση ακόμη",
        "decisionApproved": "Αποφασίστηκε",
        "hasDecision": "Καμία πρόταση ακόμη",
        "hasProposal": "Η πρόταση ανέβηκε",
        "has_proposal": "Προς απόφαση",
        "isExpired": "Η προθεσμία έληξε, δεν ανέβηκε πρόταση",
        "isExpiredHasProposal": "Η προθεσμία έληξε, η πρόταση ανέβηκε",
        "noDecision": "Το ακίνητο εξαιρείται από αυτή την απόφαση",
        "not_interested": "Χωρίς ενδιαφέρον",
        "other_decisions": "Άλλες αποφάσεις",
        "requested_changes": "Ζητήθηκαν αλλαγές",
        "waiting_for_proposal": "Αναμονή για πρόταση"
      },
      "navigation": {
        "backToDecisions": "Επιστροφή στις αποφάσεις"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Σύντομα θα έρθουν νέες αποφάσεις.",
            "title": "Ετοιμάσου να πάρεις μια απόφαση"
          },
          "no_documents": {
            "subtitle": "Εδώ θα βρεις όλα τα έγγραφα που σχετίζονται με αυτή την απόφαση",
            "title": "Ανέβασε έγγραφα που σχετίζονται με την απόφαση {decision_name}"
          }
        },
        "employees": {
          "conversations": {
            "none": {
              "subtitle": "Μόλις ανατεθεί πελάτης σε αυτό το ακίνητο, θα βλέπεις εδώ τις συνομιλίες",
              "title": "Εδώ θα βρεις όλες τις συνομιλίες για αυτή την απόφαση"
            }
          },
          "new": {
            "subtitle": "Ανάθεσε μια απόφαση σε πολλά ακίνητα με μία κίνηση",
            "title": "Δημιούργησε την πρώτη σου απόφαση"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Θα λάβεις ειδοποίηση με email όταν δημοσιευτεί νέα απόφαση.",
            "title": "Δεν έχεις ακόμη αποφάσεις"
          }
        }
      },
      "toasts": {
        "bulk_create": "Η απόφαση δημιουργήθηκε με επιτυχία | Οι αποφάσεις δημιουργήθηκαν με επιτυχία",
        "bulk_delete": "Η απόφαση διαγράφηκε με επιτυχία | Οι αποφάσεις διαγράφηκαν με επιτυχία",
        "bulk_update": "Η απόφαση ενημερώθηκε με επιτυχία | Οι αποφάσεις ενημερώθηκαν με επιτυχία",
        "update": "Η απόφαση ενημερώθηκε με επιτυχία"
      },
      "validation": {
        "amountRequired": "Το ποσό είναι υποχρεωτικό",
        "cannotUpdatePrice": "Ο προϋπολογισμός δεν μπορεί να τροποποιηθεί, επειδή δόσεις που βασίζονται σε αυτή την απόφαση έχουν γίνει ορατές στον πελάτη",
        "customer": {
          "need_not_interested_note": "Δώσε μας σχόλια για το γιατί δεν σε ενδιαφέρει αυτή η απόφαση"
        },
        "employee": {
          "need_not_interested_note": "Δώσε σχόλια για το γιατί ο πελάτης δεν ενδιαφέρεται για αυτή την απόφαση."
        },
        "installmentsSent": "Ορισμένες από τις επιλεγμένες αποφάσεις έχουν δόσεις ορατές στον πελάτη. Ο προϋπολογισμός τους θα παραμείνει ίδιος.",
        "mustBeZeroOrMore": "Πρέπει να είναι 0 ή μεγαλύτερο",
        "needAttachment": "Ανέβασε τουλάχιστον ένα νέο έγγραφο ή επίλεξε ένα από τον φάκελο του ακινήτου",
        "needNumber": "Χρειάζεται αριθμός (π.χ. 8400.5)",
        "needTitle": "Ο τίτλος είναι υποχρεωτικός",
        "need_responsible": "Χρειάζεται υπεύθυνος",
        "priceBudgetNotNegative": "Ο προϋπολογισμός δεν μπορεί να είναι αρνητικός αριθμός.",
        "responsibleRequired": "Ο υπεύθυνος είναι υποχρεωτικός",
        "selectContactPerson": "Επίλεξε τουλάχιστον 1 επαφή"
      }
    }
  }
}
